export function signDocument(certSubjectName, base64Content) {
  return new Promise((resolve, reject) => {
    if (!window.cadesplugin) return reject('CryptoPro plugin not loaded');

    window.cadesplugin.async_spawn(function* () {
      try {
        // --- Открываем хранилище ---
        const oStore = yield window.cadesplugin.CreateObjectAsync('CAdESCOM.Store');
        yield oStore.Open(
          window.cadesplugin.CAPICOM_CURRENT_USER_STORE,
          window.cadesplugin.CAPICOM_MY_STORE,
          window.cadesplugin.CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED,
        );
        // --- Ищем сертификат ---

        const oCertificates = yield (yield oStore.Certificates).Find(
          window.cadesplugin.CAPICOM_CERTIFICATE_FIND_SUBJECT_NAME,
          certSubjectName,
        );

        if ((yield oCertificates.Count) === 0) {
          yield oStore.Close();
          return reject(`Certificate not found: ${certSubjectName}`);
        }

        const oCertificate = yield oCertificates.Item(1);

        // --- Создаём Signer ---
        const oSigner = yield window.cadesplugin.CreateObjectAsync('CAdESCOM.CPSigner');
        yield oSigner.propset_Certificate(oCertificate);
        yield oSigner.propset_CheckCertificate(true);

        // --- Создаём SignedData ---
        const oSignedData = yield window.cadesplugin.CreateObjectAsync('CAdESCOM.CadesSignedData');
        yield oSignedData.propset_ContentEncoding(window.cadesplugin.CADESCOM_BASE64_TO_BINARY);
        yield oSignedData.propset_Content(base64Content);

        // Detached = false для передачи отдельно файла на бэк
        const signedMessage = yield oSignedData.SignCades(
          oSigner,
          window.cadesplugin.CADESCOM_CADES_BES,
          false,
        );

        yield oStore.Close();
        resolve(cleanBase64(signedMessage)); // очищаем подпись
      } catch (e) {
        console.log(e);

        reject(window.cadesplugin.getLastError(e));
      }
    });
  });
}
export function getCertificates() {
  return new Promise((resolve, reject) => {
    if (!window.cadesplugin) return reject('CryptoPro plugin not loaded');
    window.cadesplugin.async_spawn(function* () {
      try {
        const oStore = yield window.cadesplugin.CreateObjectAsync('CAdESCOM.Store');
        yield oStore.Open(
          window.cadesplugin.CAPICOM_CURRENT_USER_STORE,
          window.cadesplugin.CAPICOM_MY_STORE,
          window.cadesplugin.CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED,
        );
        const oStoreCerts = yield oStore.Certificates;
        const certsCount = yield oStoreCerts.Count;
        const certs = [];
        for (let i = 1; i <= certsCount; i++) {
          const cert = yield oStoreCerts.Item(i);
          const name = yield cert.SubjectName;
          certs.push({ name, cert });
        }
        yield oStore.Close();
        resolve(certs);
      } catch (e) {
        reject(window.cadesplugin.getLastError(e));
      }
    });
  });
}
export function isCryptoProAvailable() {
  return typeof window.cadesplugin !== 'undefined';
}
export async function fetchFileAsBase64(url) {
  const response = await fetch(url);
  if (!response.ok) throw new Error('Не удалось скачать файл');

  const arrayBuffer = await response.arrayBuffer();
  return arrayBufferToBase64(arrayBuffer);
}

export function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary); // Чистый Base64 без data: и переносов
}

export function cleanBase64(base64String) {
  return base64String.replace(/(\r\n|\n|\r)/gm, '');
}
